import { Component, OnInit, inject } from '@angular/core';
import {HydraCollection} from '../../../class/generic/hydra-collection';
import {api} from '../../../api/api-dictionnary';
import {Subscription} from 'rxjs';
import {HydraService} from '../../../core/services/hydra.service';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {AideSousType} from '../../../interface/api/AideSousType';
import { CdkScrollable } from '@angular/cdk/scrolling';

import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-modal-add-sous-type-aide',
    templateUrl: './modal-add-sous-type-aide.component.html',
    styleUrls: ['./modal-add-sous-type-aide.component.scss'],
    providers: [HydraService],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, FormsModule, ReactiveFormsModule, MatDialogActions, MatButton, MatDialogClose]
})
export class ModalAddSousTypeAideComponent implements OnInit {
    private hydraService = inject(HydraService);
    data = inject(MAT_DIALOG_DATA);
    dialogRef = inject<MatDialogRef<ModalAddSousTypeAideComponent>>(MatDialogRef);

    private subscriptions: Subscription[] = [];
    public typesAides = [];
    public typeAideSelected = '';
    public item = {} as AideSousType; // Item manipuler à sauvegarder
    public form: FormGroup;
    private regex = new RegExp('([A-Za-z0-9\-]+)');

    constructor() {}

    getTypesAides() {
        this.subscriptions.push(
            this.hydraService
                .getList(api.aideType)
                .subscribe((res: HydraCollection) => {
                    this.typesAides = new HydraCollection(res).getMember();
                    if (this.typesAides.length)
                        {this.typeAideSelected = this.typesAides[0].label;}
                })
        );
    }

    prepareForSave() {
        if (this.form.valid) {
            const data = this.form.value as AideSousType;
            this.typesAides.map(item => {
                if (item['label'] == this.typeAideSelected) {
                    data.aideType = item['@id'];
                }
            });
            this.dialogRef.close(data);
        }
    }
    public initFormValidator() {
        this.form = new FormGroup({
            label: new FormControl<string>(this.item.label, [Validators.required]),
            code: new FormControl<string>(this.item.code, [Validators.required]),
        });
    }

    get label() {
        return this.form.get('label');
    }
    get code() {
        return this.form.get('code');
    }

    ngOnInit() {
        this.getTypesAides();
        this.initFormValidator();
    }

    removeSpecialChar(event) {
        if(!this.regex.test(event.key)) {
            event.preventDefault();
        }
    }
}
